import { combineReducers } from 'redux'
import { NotificationsManagerReducer } from 'advenio-components'
import { AuthRedux } from 'auth-advenio'
import { resettableReducer } from 'reduxsauce'

import configureStore from './CreateStore'
import epicMiddleware from '../Observables'

export default (middlewares) => {
  /* ------------- Assemble The Reducers ------------- */
  const resettable = resettableReducer('RESET')
  const rootReducer = combineReducers({
    auth: AuthRedux.reducer,
    notifications: NotificationsManagerReducer,
    centers: require('./CentersRedux').reducer,
    companies: require('./CompaniesRedux').reducer,
    companyAccount: require('./CompanyAccountRedux').reducer,
    contacts: require('./ContactsRedux').reducer,
    contracts: require('./ContractsRedux').reducer,
    countries: require('./CountriesRedux').reducer,
    resetPassword: require('./ResetPasswordRedux').reducer,
    regimenFiscal: require('./RegimenFiscalRedux').reducer,
    users: require('./UsersRedux').reducer,
    consumiblesCategory: require('./ConsumiblesCategoryRedux').reducer,
    uso_cfdi: require('./UsoCFDIRedux').reducer,

  })

  return configureStore(resettable(rootReducer), [epicMiddleware, ...middlewares])
}



// WEBPACK FOOTER //
// ./src/Data/Redux/index.js